<mat-tab-group>

  <mat-tab label="UNDERCARRIAGE">
    <div class="alerts-container">

      <table class="alerts-table">

        <thead>
          <tr>
            <th>{{'Report Name' | translate | async}}</th>
            <th>{{'Description' | translate | async}}</th>
            <th>{{'Frequency' | translate | async}}</th>
            <th>{{'Enabled' | translate | async}}</th>
          </tr>
        </thead>

        <tbody>
          <tr *ngFor="let alert of AlertVM?.Data">

            <td>
              {{ alert.AlertName }}
            </td>

            <td>
              {{ alert.AlertDescription }}
              <button mat-icon-button *ngIf="alert.HasSetting" matTooltip="Alert Settings"
                (click)="openFleetReport(alert)" class="settings-btn">
                <mat-icon>settings</mat-icon>
              </button>
            </td>

            <td>
              <span>
                {{ alert.AlertFrequency }}
              </span>
            </td>

            <!-- MAIN ENABLE TOGGLE -->
            <td>
              <mat-slide-toggle [(ngModel)]="alert.IsEnabled" (change)="onToggleChange(alert)"
                [disabled]="alert.AlertId === 10" [matTooltip]="alert.AlertId === 10 ? 'Feature coming soon' : ''"
                matTooltipPosition="above">
              </mat-slide-toggle>
            </td>
        </tbody>
      </table>

    </div>
  </mat-tab>

  <mat-tab label="GET">
    <table class="alerts-table">
      <thead>
        <tr>
          <th>{{'Report Name' | translate | async}}</th>
          <th>{{'Description' | translate | async}}</th>
          <th>{{'Frequency' | translate | async}}</th>
          <th>{{'Enabled' | translate | async}}</th>
          <th>{{'Email Enabled' | translate | async}}</th>
        </tr>
      </thead>

      <tbody>
        <tr>

          <td>

          </td>

          <td>

          </td>

          <td>

          </td>

          <!-- MAIN ENABLE TOGGLE -->
          <td class="text-center">

          </td>

          <!-- EMAIL ENABLE TOGGLE -->
          <td class="text-center">

          </td>
        </tr>
      </tbody>
    </table>
  </mat-tab>

  <!-- <mat-tab label="Other"> -->
  <!-- <panel>
    <div class="center" *ngIf="loadingPreferences">
        <mat-spinner diameter="32"></mat-spinner>
    </div>
    <ul class="preferences" *ngIf="!loadingPreferences">
         <li>
            <preference [label]="'Alerts on the Dashboards' | translate | async" [description]="'When the box is ticked the alerts will show. ' | translate | async">
                <mat-checkbox [(ngModel)]="EnableDashboardAlerts" (click)="updateDashBoardAlertStatus($event.target)"></mat-checkbox>
            </preference>
           
        </li>
        <li>
            <preference [label]="'Undercarriage Inspections Due Emails' | translate | async" [description]="'Determines whether the sending of Inspections Due Emails is enabled or disabled. ' | translate | async">
                <mat-checkbox [(ngModel)]="InspectionsDueEmails" (click)="updateInspectionsDueEmail($event.target)"></mat-checkbox>
            </preference>

           
        </li>
        <li>
            <preference [label]="'Daily Inspections Due Emails' | translate | async" [description]="'Alerting a user of any overdue Digital Inspections which have not been completed after 40 hours. ' | translate | async">
                <mat-checkbox [(ngModel)]="DailyInspectionsDueEmails" (click)="updateDailyInspectionsDueEmail($event.target)"></mat-checkbox>
            </preference>
        </li>

       

        <li *ngIf="isSupervisor==true">
            <preference [label]="'DFI Emails' | translate | async" [description]="'Receive email alerts for DFI’s  ' | translate | async">
                <mat-checkbox [(ngModel)]="EnableDFIEmails" (click)="UpdateEnableDFIEmails($event.target)"></mat-checkbox>
            </preference> 
        </li>
      
    </ul>
</panel> -->
  <!-- </mat-tab> -->

</mat-tab-group>